import { render, staticRenderFns } from "./PowerBISelectView.vue?vue&type=template&id=0b7832b1&scoped=true&"
import script from "./PowerBISelectView.vue?vue&type=script&lang=js&"
export * from "./PowerBISelectView.vue?vue&type=script&lang=js&"
import style0 from "./PowerBISelectView.vue?vue&type=style&index=0&id=0b7832b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7832b1",
  null
  
)

export default component.exports